export const TIME = 'HH:mm';
export const DAY = 'dddd';
export const EUROPE_LONDON_TIME_ZONE = 'Europe/London';

export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DISPLAY_DATE_TIME_FORMAT = 'DD MMMM YYYY';
export const DAY_OF_WEEK_DAY_MONTH_FORMAT = 'dddd Do MMMM YYYY';
export const YYYY_MM_DD_FORMAT = 'YYYY-MM-DD';
